module.exports = __webpack_public_path__ + "MaterialIcons-Regular.woff";